import { AxiosError, AxiosRequestConfig } from "axios";

export interface ICustomAxiosError extends AxiosError {
  config: IAxiosRequestWithRetryConfig;
}

export interface IAxiosRequestWithRetryConfig extends AxiosRequestConfig {
  retry?: number;
}
